module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_blue_01-4ea4e2695e3ae41599d72ed0e18c5b89.svg";